class StickyAddToCart extends HTMLElement {
  constructor() {
    super();
    this.handleScroll = this.handleScroll.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.productName = '';
    this.swatchImg = '';
    this.swatchTitle = '';
    this.variantLabel = '';
    this.variantSelected = false;
    this.variantTitle = '';
    this.section = null;
    this.addToCartBtn = null;
    this.variantSelect = null;
    this.productForm = null;
  }

  connectedCallback() {
    // Find the main product section
    this.section = document.querySelector('featured-detailed-product, .featured-detailed-product');
    // Find the product form
    this.productForm = this.section?.querySelector('form.product-form');
    // Find the variant select
    this.variantSelect = this.productForm?.querySelector('select[data-variant-select]');
    // Find the add to cart button
    this.addToCartBtn = this.productForm?.querySelector('button[data-atc-button], .add-to-cart-button');
    // Find the product name
    const h1 = this.section?.querySelector('h1.pdp-title');
    this.productName = h1 ? h1.textContent.trim() : '';
    // Find the variant title
    this.variantTitle = this.variantSelect?.getAttribute('aria-label') || this.variantSelect?.name || 'variant';
    // Track scroll direction
    this.lastScrollY = window.scrollY;
    // Listeners
    this.updateState();
    window.addEventListener('scroll', this.handleScroll);
    this.variantSelect?.addEventListener('change', () => this.updateState());
    // Observe DOM changes for swatch updates
    this.swatchObserver = new MutationObserver(() => this.updateState());
    const swatchContainer = this.section?.querySelector('.fdp-colors');
    if (swatchContainer) {
      this.swatchObserver.observe(swatchContainer, { childList: true, subtree: true, attributes: true });
    }
    // Ensure base class for visibility
    this.classList.add('sticky-add-to-cart');
    // Keyboard accessibility for sticky bar
    this.addEventListener('keydown', this.handleKeyDown);
  }


  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    this.variantSelect?.removeEventListener('change', () => this.updateState());
    if (this.swatchObserver) this.swatchObserver.disconnect();
    this.removeEventListener('keydown', this.handleKeyDown);
  }

  updateState() {
    // Get current variant
    const value = this.variantSelect?.value;
    this.variantSelected = !!value && value !== '';
    this.variantLabel = this.variantSelected ? this.variantSelect.options[this.variantSelect.selectedIndex].text : '';
    // Get active swatch image (fix selector to match .fdp-swatch.fdp-swatch-active img)
    const swatchActive = this.section?.querySelector('.fdp-swatch.fdp-swatch-active img');
    this.swatchImg = swatchActive?.src || '';
    this.swatchTitle = swatchActive?.alt || '';
    this.render();
  }
  handleKeyDown(e) {
    // Allow keyboard activation for sticky button (Enter/Space)
    if (e.target.classList.contains('sticky-btn') && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      this.handleButtonClick();
    }
  }

  handleScroll() {
    if (!this.section || !this.addToCartBtn) return;
    const sectionRect = this.section.getBoundingClientRect();
    const sectionHeight = sectionRect.height;
    // Porcentaje restante de la sección por pasar (bottom respecto al alto)
    let percentRemaining = 0;
    if (sectionHeight > 0) {
      percentRemaining = Math.max(0, Math.min(1, sectionRect.bottom / sectionHeight));
    }
    const viewportHeight = window.innerHeight;
    const btnRect = this.addToCartBtn.getBoundingClientRect();
    const addToCartVisible = this.addToCartBtn.offsetParent !== null && btnRect.top < viewportHeight && btnRect.bottom > 0;
    // Detectar dirección del scroll
    const currentScrollY = window.scrollY;
    const scrollingDown = currentScrollY > this.lastScrollY;
    this.lastScrollY = currentScrollY;
    // Mostrar el sticky solo si el usuario ya pasó la sección (bottom de la sección está por encima del viewport) y hace scroll hacia abajo y el botón original no está visible
    const sectionPassed = percentRemaining < 0.20;
    if (sectionPassed && !addToCartVisible) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  handleButtonClick() {
    if (!this.variantSelected) {
      var section = this.closest('featured-detailed-product');
      if (section){
        var y = section.getBoundingClientRect().top + window.pageYOffset;
        $('html, body').animate({
          scrollTop: y
        }, 600);
      }else{
        this.variantSelect?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      this.variantSelect?.focus();
    } else {
      this.addToCartBtn?.focus();
      this.addToCartBtn?.click();
    }
  }

  render() {
    // Render sticky bar with ARIA roles and labels for accessibility
    this.innerHTML = `
      <div class="sticky-add-to-cart-bar" role="region" aria-label="Sticky add to cart bar">
        <diV class="title" aria-label="Product name">
          <span class="product-name">${this.productName}</span>
        </div>
        <div class="info">
          <div class="swatch-info" aria-label="${this.swatchTitle ? `Selected color swatch: ${this.swatchTitle}` : 'No color swatch selected'}">
            ${this.swatchImg ? `<img class="swatch-img" src="${this.swatchImg}" alt="${this.swatchTitle || 'Selected color swatch'}"> ${this.swatchTitle ?`<span class="swatch-title">${this.swatchTitle.split('-')[1] }</span>`:``}` : ''}
          </div>
          ${this.variantSelected ? `<span class="variant-label">${this.variantSelect?.dataset.selectTitle + ": "}${this.variantLabel}</span>` : ''}
          <button class="sticky-btn" type="button" aria-pressed="false" aria-label="${this.variantSelected ? 'Add to cart' : `${this.variantTitle}`}" tabindex="0">${this.variantSelected ? 'Add to cart' : `${this.variantTitle}`}</button>
        </div>
      </div>
    `;
    // Click and keyboard accessibility for sticky button
    const stickyBtn = this.querySelector('.sticky-btn');
    if (stickyBtn) {
      stickyBtn.onclick = this.handleButtonClick;
      stickyBtn.onkeydown = this.handleKeyDown;
    }
    // Ensure visibility class is synced after render
    this.handleScroll();
  }
}

customElements.define('sticky-add-to-cart', StickyAddToCart);
